import React from 'react';
import {EyeIcon, EyeOffIcon} from '@heroicons/react/outline'
import {Popover, Transition} from "@headlessui/react";
import cn from "classnames";
import IconCertificate from "../components/icon/IconCertificate";

type Props = {
  visible: boolean
  className?: string
}

export default function ContactVisibilityStatus({ visible, className }: Props) {
  const status = visible ? <div className={className}><EyeIcon className="h-5 w-5 text-green inline-block mb-1 "/> Visible in API</div>
    : <div className={className}><EyeOffIcon className="h-5 w-5 fa text-red inline-block mb-1 "/> Hidden in API</div>;
  return (
    <Popover className="relative">
      <Popover.Button>
        <div className={cn(className, 'border-dotted border-b')}>
          {status}
        </div>
      </Popover.Button>

      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Popover.Panel className="absolute z-10 p-3 mt-2 bg-white w-64 rounded border border-gray shadow-lg">
          <div className="text-sm">
            This contact is {visible ? 'visible' : 'hidden'} in the API. When the contact is hidden, it will not be
            returned by the API `/contacts` endpoint.
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>

  );

}
